<template>
  <scout-topic-panel
    :title="title"
    name="reservation"
    :tooltip="tooltip"
  >
    <router-link
      :to="{ name: 'scoutReservation', params: { contractId: contractId , jobId: jobId } }"
      class="pega-text-link"
    >
      <span
        data-test="link-text"
        class="boss-scoutandlike-text"
      >{{ reservationCount }}件({{ reservationUserCount }}名)</span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import { mapGetters } from 'vuex'
export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    reservationCount: {
      type: Number,
      default: 0
    },
    reservationUserCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'isSendScout'
    ]),
    title () {
      return `スカウト予約の確認${this.isSendScout ? '・編集' : ''}`
    },
    tooltip () {
      return `スカウト予約確認${this.isSendScout ? '、編集、削除' : ''}ができます。`
    }
  }
}
</script>
